import { jsx } from '@emotion/react/jsx-runtime';
import { createContext } from 'react';

const HighContrastContext = /*#__PURE__*/ createContext(false);
function HighContrastProvider({ children, value }) {
    return /*#__PURE__*/ jsx(HighContrastContext.Provider, {
        value: value,
        children: children
    });
}

export { HighContrastContext, HighContrastProvider };
//# sourceMappingURL=high-contrast-context.js.map
